import { useBanner } from 'contexts/BannerContext';

import sizes from '@polyai/ui/styles/config/sizes';

const useBannerOffset = () => {
  const { isBannerShown } = useBanner();

  return isBannerShown ? sizes.bannerHeight : 0;
};

export default useBannerOffset;
